import { Injectable } from '@angular/core';
import { UserModel } from '../../assets/models/user/User.model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  #userFromDb$: BehaviorSubject<UserModel | null> = new BehaviorSubject<UserModel | null>(null);
  #email$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  #isActivated$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
  }

  setEmail$(email: string): void {
    this.#email$.next(email);
  }

  getEmail$(): Observable<string | null> {
    return this.#email$.asObservable();
  }

  setUserIsActivated$(isActivated: boolean): void {
    this.#isActivated$.next(isActivated);
  }

  setUserFromDb$(user?: UserModel): void {
    if (!user) {
      return;
    }
    this.#userFromDb$.next(user);
  }
}
